import Body from "../../../../../../material/skeleton/Body";
import {useEffect} from "react";
import useQuotationRepository from "../../../../../../repository/insurance/useQuotationRepository";
import isNull from "../../../../../../mixin/isNull";
import LoadingData from "../../../emergency/step/common/LoadingData";
import Box from "@mui/material/Box";
import {Chip, Divider, Paper, Slide} from "@mui/material";
import {CheckCircle, HourglassEmpty, Info} from "@mui/icons-material";
import Typography from "@mui/material/Typography";

export default function ({interventionId}) {
    const quotationRepository = useQuotationRepository();
    /** @type Quotation */
    const quotation = quotationRepository.findOneByInterventionId(interventionId).select();

    useEffect(() => {
        quotationRepository.findOneByInterventionId(interventionId).exec();
    }, []);

    if (isNull(quotation)) return <LoadingData/>;

    return (
        <Body>
            <Box mt={2}>
                <Slide direction={"left"} in={true} timeout={500}>
                    <Paper elevation={3}>
                        <Box
                            display="flex"
                            alignItems={"center"}
                            px={2}
                            py={1}
                        >
                            <Box display="flex" alignItems={"center"}>
                                <Info color={"warning"}/>
                            </Box>
                            <Box ml={1}>
                                <Typography>
                                    Votre devis a été soumis et est en cours de validation.
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Slide>
            </Box>
            <Box mt={4} px={2}>
                <Paper elevation={1}>
                    <Box px={2} py={1}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            pt={1}
                            pb={2}
                        >
                            <Typography>Validation Fairfair</Typography>
                            {
                                quotation.isValidatedByFairfair()
                                    ? (
                                        <Chip
                                            icon={<CheckCircle/>}
                                            label="Validé"
                                            color="success"
                                            size="small"
                                        />
                                    )
                                    : (
                                        <Chip
                                            icon={<HourglassEmpty/>}
                                            label="En attente"
                                            color="warning"
                                            size="small"
                                        />
                                    )
                            }
                        </Box>
                        <Divider/>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            pt={2}
                            pb={1}
                        >
                            <Typography>Validation prescripteur</Typography>
                            {
                                quotation.isValidatedByPrescriber()
                                    ? (
                                        <Chip
                                            icon={<CheckCircle/>}
                                            label="Validé"
                                            color="success"
                                            size="small"
                                        />
                                    )
                                    : (
                                        <Chip
                                            icon={<HourglassEmpty/>}
                                            label="En attente"
                                            color="warning"
                                            size="small"
                                        />
                                    )
                            }
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Body>
    );
}
